import React from "react";
import {CustomerFluidSubPageLayout} from "../../layouts/customerLayout/customerFluidSubPageLayout/CustomerFluidSubPageLayout";
import {CustomerOrderDetail} from "./customerOrderDetail/CustomerOrderDetail";
import {CustomerMenuHeader} from "components/layouts/customerLayout/components/customerMenuHeader";

const CustomerOrderDetailPage = ({deliveryId}) => {
    return (
        <CustomerFluidSubPageLayout pageTitle="Sipariş Detayı">
            <CustomerMenuHeader />
            <CustomerOrderDetail deliveryId={deliveryId} />
        </CustomerFluidSubPageLayout>
    );
};

export default CustomerOrderDetailPage;
